module.exports = __webpack_public_path__ + "media/images/lp_v6_check3-86f293a080500bd6d4984a8b90244e52.webp";